module.exports = __webpack_public_path__ + "img/background-s2-min.6df4dcdc.png";